module.exports = __webpack_public_path__ + "static/media/xray__complete.86655c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/xRay/xray__complete.png
// module id = 915
// module chunks = 0